import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from '../store'
import {
  getTosAndPrivacyPolicy,
  postTosAndPrivacyPolicyAgreement,
} from '../../apis/tosAndPrivacyPolicy'
import { setErrors } from '../common/errorsSlice'
import { TosAndPrivacyPolicyResponse, TosAndPrivacyPolicyRequest } from '../../types/tosAndPrivacyPolicy'

interface TosAndPrivacyPolicyState {
  agreed: boolean | undefined
  version: number | null
  tos: string | null
  privacy_policy: string | null
  isLoading: boolean
}

const initialState: TosAndPrivacyPolicyState = {
  agreed: undefined,
  version: null,
  tos: null,
  privacy_policy: null,
  isLoading: true,
}

const tosAndPrivacyPolicySlice = createSlice({
  name: 'tosAndPrivacyPolicy',
  initialState,
  reducers: {
    requestStart: (state) => {
      state.isLoading = true
      return state
    },
    getTosAndPrivacyPolicySuccess: (state, action: PayloadAction<TosAndPrivacyPolicyResponse>) => {
      // eslint-disable-next-line no-param-reassign
      state = {
        ...action.payload,
        isLoading: false,
      }
      return state
    },
    postTosAndPrivacyPolicyAgreementSuccess: (state) => {
      state.agreed = true
      return state
    },
    requestFailure: (state) => {
      state.isLoading = false
      return state
    },
  },
})

export const {
  requestStart,
  getTosAndPrivacyPolicySuccess,
  postTosAndPrivacyPolicyAgreementSuccess,
  requestFailure,
} = tosAndPrivacyPolicySlice.actions

export const tosAndPrivacyPolicyReducer = tosAndPrivacyPolicySlice.reducer

export const fetchTosAndPrivacyPolicy = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getTosAndPrivacyPolicy()
    .then((result) => {
      dispatch(getTosAndPrivacyPolicySuccess(result))
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const createTosAndPrivacyPolicyAgreement = (
  params: TosAndPrivacyPolicyRequest,
  callback: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  postTosAndPrivacyPolicyAgreement(params)
    .then(() => {
      dispatch(postTosAndPrivacyPolicyAgreementSuccess())
      callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}
